import { Typography } from "@material-ui/core"
import { useSnackbar, VariantType } from "notistack"
import React, { createContext, useContext, useEffect, useState } from "react"
import { buscarDadosRetrospectiva } from "../../../services/apiLambdaRetrospectiva"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"

type RetrospectivaContextType = {
    dadosRetrospectiva: DadosRetrospectiva | null
}

type TopProduto = {
    nome: string
    qtdVendido: number
    urlImagem: string
}

type TopCliente = {
    nome: string
    telefone: string
    qtdPedidos: number
}

type TopBairro = {
    bairro: string
    qtd: number
}

export type DadosRetrospectiva = {
    pedidos: {
        quantidade: number
        faturamento: number
    }
    topProdutos: TopProduto[]
    topClientes: TopCliente[]
    topBairros: TopBairro[]
    clientes: {
        clientesFieis: number
        novosClientes: number
    }
    cartelasResgatadas: number
    estabelecimento: {
        nome: string
        urlLogo: string
    }
    retornoErro?: number
    mensagem?: string
}

export const RetrospectivaContext = createContext<RetrospectivaContextType | null>(null)

type Props = {
    children: React.ReactNode
}

export function RetrospectivaContextProvider({ children }: Props) {
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg: string | null, tipo: VariantType | undefined) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const params = new URLSearchParams(window.location.search)
    const b64: string = String(params.get("b64"))

    const [dadosRetrospectiva, setDadosRetrospectiva] = useState<DadosRetrospectiva | null>(null)
    const [erro, setErro] = useState(false)

    const buscarDados = async () => {
        try {
            setLoading(true)
            const response = await buscarDadosRetrospectiva(b64)
            if (response?.retornoErro) {
                console.error("Erro", response?.retornoErro)
                alertStart("Erro ao buscar dados", "error")
                setErro(true)
                setDadosRetrospectiva(null)
            } else {
                setDadosRetrospectiva(response as any)
            }
        } catch (error: any) {
            console.error("Erro ao buscar dados")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!dadosRetrospectiva) {
            buscarDados()
        }
    }, [])

    return (
        <RetrospectivaContext.Provider value={{ dadosRetrospectiva }}>
            <Loading />
            {dadosRetrospectiva ? (
                children
            ) : !erro ? (
                <div
                    style={{
                        width: "100vw",
                        height: "100dvh",
                        backgroundColor: "#3B3B3B",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography>...</Typography>
                </div>
            ) : (
                erro && (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography>Erro ao buscar dados</Typography>
                    </div>
                )
            )}
        </RetrospectivaContext.Provider>
    )
}

export const useRetrospectiva = () => {
    const context = useContext(RetrospectivaContext)
    if (!context)
        throw new Error("useRetrospectiva deve ser usado dentro de RetrospectivaContextProvider")
    return context.dadosRetrospectiva
}
